/* eslint-disable react/prop-types */
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const DialogModal = ({
  open,
  handleClose,
  children,
  title,
  maxWidth = 'md', 
  showCloseIcon = true
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={maxWidth}
      fullWidth
      scroll="paper" 
      BackdropProps={{
    sx: {
      backdropFilter: 'blur(6px)',   
      backgroundColor: 'rgba(0,0,0,0.4)'
    }
  }}  
    >
      {(title || showCloseIcon) && (
        <DialogTitle
          id="dialog-modal-title"
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontWeight: 600
          }}
        >
          {title}

          {showCloseIcon && (
            <IconButton id="btn-dialog-modal-close" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          )}
        </DialogTitle>
      )}

      <DialogContent id="dialog-modal-content" dividers>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default DialogModal;